const availablePaymentMethods = {
  VI: {
    filename: 'logo_VI',
    id: 1,
    type: 'CARD',
  },
  VD: {
    filename: 'logo_VD',
    id: 2,
    type: 'CARD',
  },
  VE: {
    filename: 'logo_VE',
    id: 3,
    type: 'CARD',
  },
  VC: {
    filename: 'logo_VC',
    id: 4,
    type: 'CARD',
  },
  CA: {
    filename: 'logo_CA',
    id: 5,
    type: 'CARD',
  },
  MO: {
    filename: 'logo_MO',
    id: 5,
    type: 'CARD',
  },
  MD: {
    filename: 'logo_MD',
    id: 6,
    type: 'CARD',
  },
  EC: {
    filename: 'logo_EC',
    id: 8,
    type: 'CARD',
  },
  DC: {
    filename: 'logo_DC',
    id: 9,
    type: 'CARD',
  },
  DS: {
    filename: 'logo_DS',
    id: 10,
    type: 'CARD',
  },
  AX: {
    filename: 'logo_AX',
    id: 11,
    type: 'CARD',
  },
  AC: {
    filename: 'logo_AC',
    id: 12,
    type: 'CARD',
  },
  RU: {
    filename: 'logo_RU',
    id: 13,
    type: 'CARD',
  },
  Affirm: {
    filename: 'affirm',
    id: 14,
    type: 'WALLET',
  },
  ApplePay: {
    filename: 'applepay',
    id: 16,
    type: 'WALLET',
  },
  Bancontact: {
    filename: 'bancontact',
    id: 17,
    type: 'WALLET',
  },
  GooglePay: {
    filename: 'googlepay',
    id: 18,
    type: 'WALLET',
  },
  IDeal: {
    filename: 'ideal',
    id: 19,
    type: 'WALLET',
  },
  PayPal: {
    filename: 'paypal',
    id: 20,
    type: 'WALLET',
  },
  Sofort: {
    filename: 'sofort',
    id: 21,
    type: 'WALLET',
  },
  Trustly: {
    filename: 'trustly',
    id: 22,
    type: 'WALLET',
  },
};

export default availablePaymentMethods;
